export default "__VITE_ASSET__BdPt4tYc__"